import { Input } from "@/components/ui/input"

interface PriceRangeFilterProps {
  min: string
  max: string
  onMinChange: (val: string) => void
  onMaxChange: (val: string) => void
  text: { min: string; max: string }
}

export const PriceRangeFilter = ({
  min,
  max,
  onMinChange,
  onMaxChange,
  text,
}: PriceRangeFilterProps) => {
  return (
    <div className="flex items-center gap-4">
      <div className="group relative flex-1">
        <span className="absolute left-4 top-1/2 -translate-y-1/2 text-sm font-bold text-muted-foreground/60 transition-colors group-focus-within:text-primary">
          $
        </span>
        <Input
          type="number"
          placeholder={text.min}
          value={min}
          onChange={(e) => onMinChange(e.target.value)}
          className="h-12 rounded-none border-0 bg-bone/80 pl-8 text-sm font-semibold transition-all hover:bg-bone focus-visible:bg-bone focus-visible:ring-1 focus-visible:ring-accent/30 dark:bg-muted/30 dark:hover:bg-muted/50 dark:focus-visible:bg-muted/50"
        />
      </div>

      <span className="text-muted-foreground/40">-</span>

      <div className="group relative flex-1">
        <span className="absolute left-4 top-1/2 -translate-y-1/2 text-sm font-bold text-muted-foreground/60 transition-colors group-focus-within:text-primary">
          $
        </span>
        <Input
          type="number"
          placeholder={text.max}
          value={max}
          onChange={(e) => onMaxChange(e.target.value)}
          className="h-12 rounded-none border-0 bg-bone/80 pl-8 text-sm font-semibold transition-all hover:bg-bone focus-visible:bg-bone focus-visible:ring-1 focus-visible:ring-accent/30 dark:bg-muted/30 dark:hover:bg-muted/50 dark:focus-visible:bg-muted/50"
        />
      </div>
    </div>
  )
}

